// extracted by mini-css-extract-plugin
export var content = "footer-module--content--a0175";
export var legal = "footer-module--legal--92401";
export var legals = "footer-module--legals--0ecca";
export var logo = "footer-module--logo--62df3";
export var logoImg = "footer-module--logoImg--968a0";
export var logoImgPrint = "footer-module--logoImgPrint--29457";
export var logoText = "footer-module--logoText--eb524";
export var nav = "footer-module--nav--5749c";
export var navItem = "footer-module--navItem--b4ef7";
export var navItems = "footer-module--navItems--be883";
export var navLink = "footer-module--navLink--e952e";
export var printFooter = "footer-module--printFooter--63a18";
export var root = "footer-module--root--0c234";
export var t4k = "footer-module--t4k--8b7dd";
export var t4kText = "footer-module--t4k-text--4f6e6";
export var timeForKids = "footer-module--timeForKids--101cd";
export var timeForKidsPrint = "footer-module--timeForKidsPrint--0833c";